import React from "react";
import { Link } from "react-router-dom";

const TopSection = ({ courseData }) => {
  if (!courseData) {
    return (
      <div className="bg-sddarkgray text-white flex items-center justify-center h-32">
        <p>Course not found.</p>
      </div>
    );
  }

  const { title, selectedImage, credits, duration, cost } = courseData;

  return (
    <div className="relative w-full h-[530px] md:h-[400px] lg:h-[500px]">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${selectedImage})` }}
      ></div>
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      <div className="relative max-w-6xl mx-auto md:h-full top-28 md:top-0 flex flex-col justify-center items-center text-white text-center px-4">
        <h2 className="text-2xl md:text-3xl font-bold bg-sdbodywhite text-black p-4 max-w-xl rounded-xl">
          {title}
        </h2>
        <p className="text-sm md:text-base mt-3 opacity-80">
          Home • Academic Programmes • {title}
        </p>
      </div>
      <div className="absolute bottom-0 w-full bg-sdbodywhite bg-opacity-10 py-4">
        <div className="max-w-5xl mx-auto md:flex md:flex-wrap justify-center gap-4 p-4 md:p-0 space-y-2 md:space-y-0">
          <div className="px-4 py-2 bg-sdorange text-black font-semibold border-b-2 border-black rounded">
            Credits: <span className="text-blue-700">{credits}</span>
          </div>
          <div className="px-4 py-2 bg-sdorange text-black font-semibold border-b-2 border-black rounded">
            Duration: <span className="text-blue-700">{duration}</span>
          </div>
          <div className="px-4 py-2 bg-sdorange text-black font-semibold border-b-2 border-black rounded">
            Cost: <span className="text-blue-700">{cost}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSection;
